// extracted by mini-css-extract-plugin
export default {"loader":"_3NybZFH-OOgr0AllHuafiM","spinner":"_12ildXefOKRUj-RAp6wWQH"};